import FallbackLoader from './FallbackLoader';

export default FallbackLoader(() => import(/* webpackChunkName: "async-ProposeSaveSearchModal" */'shared-components/components/ProposeSaveSearchModal'));
